import Vue from 'vue';
import Router from 'vue-router';

Vue.use(Router);

const routes = [
  {
    path: '*',
    redirect: '/home',
    meta: {
      title: '商城',
      auth: false
    }
  },
  {
    name: 'nt/errorpage',
    component: () => import('./view/error'),
    meta: {
      title: '错误',
      auth: false
    }
  },
  {
    name: 'nt/sucesspage',
    component: () => import('./view/sucess'),
    meta: {
      title: '完成',
      auth: false
    }
  },
  {
    name: 'catalogitems/:id(\\d+)',
    component: () => import('./view/catalog'),
    meta: {
      title: '分类',
      auth: true
    }
  },
  {
    name: 'catalog',
    component: () => import('./view/catalog'),
    meta: {
      title: '分类',
      auth: true
    }
  },
  {
    name: 'favorites',
    component: () => import('./view/favorites'),
    meta: {
      title: '收藏夹',
      auth: true
    }
  },
  // {
  //   name: 'result',
  //   component: () => import('./view/catalog/items'),
  //   meta: {
  //     title: '查询'
  //   }
  // },
  {
    name: 'nt/goods/:id(\\d+)',
    component: () => import('./view/goods'),
    meta: {
      title: '商品详情',
      auth: true
    }
  },
  {
    name: 'cart',
    component: () => import('./view/cart'),
    meta: {
      title: '购物车',
      auth: true
    }
  },
  {
    name: 'order',
    component: () => import('./view/cart/order'),
    meta: {
      title: '下单',
      auth: true
    }
  },
  {
    name: 'order/:id(\\d+)',
    component: () => import('./view/user/orderinfo'),
    meta: {
      title: '订单详情',
      auth: true
    }
  },
  {
    name: 'nt/clslist',
    component: () => import('./view/directsell/clslist'),
    meta: {
      title: '在线商城',
      auth: true
    }
  },
  {
    name: 'nt/listitems',
    component: () => import('./view/directsell/listitems'),
    meta: {
      title: '商城查询',
      auth: true
    }
  },
  {
    name: 'nt/directsell',
    component: () => import('./view/directsell'),
    meta: {
      title: '改装升级',
      auth: true
    }
  },
  {
    name: 'nt/directsell/:id(\\d+)',
    component: () => import('./view/directsell/item'),
    meta: {
      title: '改装升级订单',
      auth: true
    }
  },
  {
    name: 'directsellslist',
    component: () => import('./view/directsell/orderlist'),
    meta: {
      title: '改装升级列表',
      auth: true
    }
  },
  {
    name: 'nt/directsellinfo/:id(\\d+)',
    component: () => import('./view/directsell/orderinfo'),
    meta: {
      title: '改装升级信息',
      auth: true
    }
  },
  {
    name: 'nt/directsell/order',
    component: () => import('./view/directsell/order'),
    meta: {
      title: '改装升级订单',
      auth: true
    }
  },
  {
    name: 'nt/ordermsg/:id(\\d+)',
    component: () => import('./view/user/ordermsg'),
    meta: {
      title: '交流信息',
      auth: true
    }
  },
  {
    name: 'user',
    component: () => import('./view/user'),
    meta: {
      title: '会员中心',
      auth: true
    }
  },
  {
    name: 'user/orders/:id(\\d+)',
    component: () => import('./view/user/orders'),
    meta: {
      title: '我的订单',
      auth: true
    }
  },
  {
    name: 'user/coupons',
    component: () => import('./view/user/coupons'),
    meta: {
      title: '我的优惠券',
      auth: true
    }
  },
  {
    name: 'user/storedcard',
    component: () => import('./view/user/storedcard'),
    meta: {
      title: '我的储值卡',
      auth: true
    }
  },
  {
    name: 'user/vouchers',
    component: () => import('./view/user/vouchers'),
    meta: {
      title: '我的兑换券',
      auth: true
    }
  },
  {
    name: 'nt/user/coupons',
    component: () => import('./view/user/coupons'),
    meta: {
      title: '我的优惠券',
      auth: true
    }
  },
  {
    name: 'nt/shop/couponreceive',
    component: () => import('./view/shop/couponreceive'),
    meta: {
      title: '领优惠券',
      auth: true
    }
  },
  {
    name: 'nt/user/mycoupon',
    component: () => import('./view/user/mycoupon'),
    meta: {
      title: '我的券',
      auth: true
    }
  },
  {
    name: 'nt/user/coupondetail',
    component: () => import('./view/user/coupondetail'),
    meta: {
      title: '券',
      auth: true
    }
  },
  {
    name: 'nt/user/storedcard',
    component: () => import('./view/user/storedcard'),
    meta: {
      title: '我的储值卡',
      auth: true
    }
  },
  {
    name: 'nt/user/vouchers',
    component: () => import('./view/user/vouchers'),
    meta: {
      title: '我的兑换券',
      auth: true
    }
  },
  // {
  //   name: 'user/usehistory',
  //   component: () => import('./view/user/usehistory'),
  //   meta: {
  //     title: '使用清单',
  //     auth: true
  //   }
  // },
  // {
  //   name: 'nt/user/usehistory',
  //   component: () => import('./view/user/usehistory'),
  //   meta: {
  //     title: '使用清单',
  //     auth: true
  //   }
  // },
  {
    name: 'nt/user/shopinfo',
    component: () => import('./view/user/shopinfo'),
    meta: {
      title: '店铺简介',
      auth: true
    }
  },
  {
    name: 'nt/user/followshop',
    component: () => import('./view/user/followshop'),
    meta: {
      title: '关注店铺',
      auth: true
    }
  },
  {
    name: 'nt/shop/shareshop/:vipId(\\d+)',
    component: () => import('./view/shop/shareshop'),
    meta: {
      title: '分享店铺',
      auth: true
    }
  },
  {
    name: 'nt/shop/preferentialsales',
    component: () => import('./view/shop/preferentialsales'),
    meta: {
      title: '优惠咨询',
      auth: true
    }
  },
  {
    name: 'nt/shop/messagedetail/:id(\\d+)',
    component: () => import('./view/shop/messagedetail'),
    meta: {
      title: '消息详情',
      auth: true
    }
  },
  {
    name: 'nt/shop/shareshop1/:vipId(\\d+)',// 好友打开分享页面显示内容
    component: () => import('./view/shop/shareshop1'),
    meta: {
      title: '分享店铺',
      auth: true
    }
  },
  {
    name: 'home',
    component: () => import('./view/home'),
    meta: {
      title: '商品详情',
      auth: true
    }
  },
  {
    name: 'nt/user/membercentre',
    component: () => import('./view/user/membercentre'),
    meta: {
      title: '会员中心',
      auth: true
    }
  },
  {
    name: 'membercentre',
    component: () => import('./view/user/membercentre'),
    meta: {
      title: '我的',
      auth: true
    }
  },
  {
    name: 'nt/user/vipinfo',
    component: () => import('./view/user/vipinfo'),
    meta: {
      title: '会员信息',
      auth: true
    }
  },
  {
    name: 'nt/user/cardpackage',
    component: () => import('./view/user/cardpackage'),
    meta: {
      title: '办卡套餐',
      auth: true
    }
  },
  {
    name: 'nt/user/consumptionrecords',
    component: () => import('./view/user/consumptionrecords'),
    meta: {
      title: '消费记录',
      auth: true
    }
  },
  {
    name: 'nt/user/dinnercard',
    component: () => import('./view/user/dinnercard'),
    meta: {
      title: '套餐卡',
      auth: true
    }
  },
  {
    name: 'nt/user/dinnercarddetail/:id(\\d+)',
    component: () => import('./view/user/dinnercarddetail'),
    meta: {
      title: '套餐卡明细',
      auth: true
    }
  },
  {
    name: 'nt/user/maintenance',
    component: () => import('./view/user/repairremind'),
    meta: {
      title: '我的保养',
      auth: true
    }
  },
  // {
  //   name: 'nt/repair',
  //   component: () => import('./view/repair/list'),
  //   meta: {
  //     title: '维修服务'
  //   }
  // },
  {
    name: 'nt/repair/:id(\\d+)',
    component: () => import('./view/repair/item'),
    meta: {
      title: '服务工单详情',
      auth: true
    }
  },
  {
    name: 'nt/user/complaint',
    component: () => import('./view/user/complaint'),
    meta: {
      title: '投诉建议',
      auth: true
    }
  },
  {
    name: 'nt/user/complaintcreate',
    component: () => import('./view/user/complaintcreate'),
    meta: {
      title: '提交建议',
      auth: true
    }
  },
  {
    name: 'nt/user/booking',
    component: () => import('./view/user/booking'),
    meta: {
      title: '我的预约',
      auth: true
    }
  },
  {
    name: 'nt/user/bookingcreate',
    component: () => import('./view/user/bookingcreate'),
    meta: {
      title: '新增预约',
      auth: true
    }
  },
  {
    name: 'nt/user/bookingdetail/:id(\\d+)',
    component: () => import('./view/user/bookingdetail'),
    meta: {
      title: '预约详情',
      auth: true
    }
  },
  {
    // name: 'nt/activities/shopact/:id(\\d+)/:sid(\\d+)/:shareid(\\S+))',
    name: 'nt/activities/shopact/:id(\\d+)/',
    component: () => import('./view/activities/shopact/index'),
    meta: {
      title: '店铺活动',
      auth: true
    }
  },
  {
    // name: 'nt/activities/shopact/:id(\\d+)/:sid(\\d+)/:shareid(\\S+))',
    name: 'nt/activities/shopactview/:id(\\d+)/',
    component: () => import('./view/activities/shopact/view'),
    meta: {
      title: '店铺活动',
      auth: false
    }
  },
  {
    // name: 'nt/activities/shopact/:id(\\d+)/:sid(\\d+)/:shareid(\\S+))',
    name: 'nt/activities/shopactbuy/:id(\\d+)/',
    component: () => import('./view/activities/shopact/buy'),
    meta: {
      title: '店铺活动',
      auth: true
    }
  },
  {
    // name: 'nt/activities/shopact/:id(\\d+)/:sid(\\d+)/:shareid(\\S+))',
    name: 'nt/activities/shopactbuyresult/:id(\\d+)/',
    component: () => import('./view/activities/shopact/buyresult'),
    meta: {
      title: '购买完成',
      auth: true
    }
  },
  {
    name: 'nt/activities/wechatmasscoupon/:id(\\d+)/',
    component: () => import('./view/activities/wechatmasscoupon/index'),
    meta: {
      title: '微信优惠券',
      auth: true
    }
  },
  {
    name: 'nt/user/userbind/:shopId(\\d+)/:vipId(\\d+)',
    component: () => import('./view/user/userbind'),
    meta: {
      title: '用户绑定',
      auth: true
    },
  },
  {
    name: 'nt/usedcar/',
    component: () => import('./view/usedcar/index'),
    meta: {
      title: '精选好车',
      auth: true
    },
  },
  {
    name: 'nt/usedcar/:id(\\d+)/',
    component: () => import('./view/usedcar/item'),
    meta: {
      title: '车辆资料',
      auth: true
    },
  },
  {
    name: 'nt/usedcarfavorites/',
    component: () => import('./view/usedcar/favorites'),
    meta: {
      title: '我的收藏',
      auth: true
    },
  },
  {
    name: 'nt/user/mycars',
    component: () => import('./view/user/mycars'),
    meta: {
      title: '我的车辆',
      auth: true
    },
  },
  {
    name: 'nt/usedcarbuy/:id(\\d+)/',
    component: () => import('./view/usedcar/buy'),
    meta: {
      title: '确认下单',
      auth: true
    },
  },
  {
    name: 'nt/usedcarbuyresult/:id(\\d+)/',
    component: () => import('./view/usedcar/buyresult'),
    meta: {
      title: '确认下单',
      auth: true
    },
  },
  {
    name: 'nt/usedcarorders/',
    component: () => import('./view/usedcar/orders'),
    meta: {
      title: '二手车订单',
      auth: true
    },
  },
  {
    name: 'nt/usedcarorderview/:id(\\d+)/',
    component: () => import('./view/usedcar/order'),
    meta: {
      title: '订单信息',
      auth: true
    },
  },
];

// add route path
routes.forEach(route => {
  route.path = route.path || '/' + (route.name || '');
});

const router = new Router({ routes });

import axios from 'axios'
axios.defaults.headers['Accept'] = 'application/json'
axios.defaults.headers['Content-Type'] = 'application/json'
import { getUserInfoApi } from '@/api/market'
import { 
  setOpenId, 
  getOpenId, 
  baseAuthURL 
} from '@/utils/auth'
import { setCurrentWechatUsr } from '@/utils/localutils'
import { wxBaseURL } from '@/config/constant'

var isLogin = false // 已经认证
// var skipLogined = false // 已经跳过登录

router.beforeEach((to, from, next) => {
  const code = GetQueryString('code')
  const title = to.meta && to.meta.title;
  if (title) {
    document.title = title;
  }
  // console.log('form')
  // console.log(code)
  // console.log('from')
  // console.log(from)
  // console.log('to auth')
  // console.log(to)
  // console.log(to.meta.auth)
  // console.log('next')
  // console.log(next)
  // console.log('beforeEach')
  // console.log(from.path)
  // console.log(from.meta)
  // console.log(from.meta.auth)
  // console.log('to')
  // console.log(to.path)
  // console.log(to.mata)
  // console.log(to.meta.auth)
  if (to.meta.auth) {
    if (code && !isLogin) {
      // 有code，则需要认证
      console.log('router auth: code =' + code)
      axios.get(getUserInfoApi + '?code=' + code).then((ret) => {
        const openid = ret.openid
        // console.log(ret)
        // console.log('router auth: openid =' + ret.openid)
        setOpenId(openid)
        setCurrentWechatUsr(ret)
        isLogin = true
        next()
      })
    } else {
      const openid = getOpenId()
      if (!openid) {
        isLogin = false
        // console.log('router auth: 本地没有数据信息')
        // // var url = process.env.VUE_APP_WEB_URL + to.path
        // console.log(process)
        // console.log(process.env)
        // console.log(url)
        // 没有code,本地又没有数据,则需要认证
        var b = wxBaseURL + to.path
        var url = baseAuthURL(encodeURIComponent(b))
        window.location.href = url
      } else {
        isLogin = true
        console.log('router auth: 本地有数据信息')
        next()
      }   
    }
    // skipLogined = false
    console.log('need')
  } else {
    // console.log('skipLogined')
    // console.log(skipLogined)
    // if (!skipLogined) {
    //   skipLogined = true
    //   console.log(to.path)
    //   return next({
    //     path: to.path
    //   })
    // } else {
    //   next()
    // }
    // skipLogined = true
    next()
  }
  // if (!isLogin && to.path.indexOf('shopactview')) {
  //   isLogin = true
  //   return next({
  //     path: to.path
  //   })
  // } else {
  //   next()
  // }
  

  // // new
  // if (!to.path.indexOf('shopactview')>=0) {
  //   if (code && !isLogin) {
  //     // 有code，则需要认证
  //     console.log('router auth: code =' + code)
  //     // axios.get(getUserInfoApi + '?code=' + code).then((ret) => {
  //     //   const openid = ret.openid
  //     //   console.log(ret)
  //     //   console.log('router auth: openid =' + ret.openid)
  //     //   setOpenId(openid)
  //     //   setCurrentWechatUsr(ret)
  //     //   isLogin = true
  //     //   next()
  //     // })
  //   } else {
  //     const openid = getOpenId()
  //     if (!openid) {
  //       isLogin = false
  //       console.log('router auth: 本地没有数据信息')
  //       var url = process.env.VUE_APP_WEB_URL + to.path
  //       console.log(process)
  //       console.log(process.env)
  //       console.log(url)
  //       // next({
  //       //   path: to.path
  //       // })
  //       // window.location.href = url
  //       // 没有code,本地又没有数据,则需要认证
  //       // var b = wxBaseURL + to.path
  //       // var url = baseAuthURL(encodeURIComponent(b))
  //       // window.location.href = url
  //     } else {
  //       isLogin = true
  //       console.log('router auth: 本地有数据信息')
  //       next()
  //     }
  //   }
  // } else {
  //   isLogin = true
  //   console.log('next')
  //   // next({
  //   //   path: to.path
  //   // })
  // }
  
});

function GetQueryString(name)
{
     var reg = new RegExp("(^|&)"+ name +"=([^&]*)(&|$)");
     var r = window.location.search.substr(1).match(reg);
     if(r!=null)return  unescape(r[2]); return null;
}

// function RequireAuth(to) {
//   if (to.mata.auth)
// }

export {
  router
};
